// Meta Pixel ID
const PIXEL_ID = '88264557791221'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined') return // Inject Meta Pixel script
  ;(function (f: Window, b: Document, e: string, v: string) {
    if (f.fbq) return
    const n = function (...args: unknown[]) {
      if ((n as unknown as { callMethod: Function }).callMethod) {
        ;(n as unknown as { callMethod: Function }).callMethod.apply(n, args)
      } else {
        ;(n as unknown as { queue: unknown[] }).queue.push(args)
      }
    } as unknown as Window['fbq']
    ;(
      n as unknown as {
        push: unknown
        loaded: boolean
        version: string
        queue: unknown[]
      }
    ).push = n
    ;(n as unknown as { loaded: boolean }).loaded = true
    ;(n as unknown as { version: string }).version = '2.0'
    ;(n as unknown as { queue: unknown[] }).queue = []
    f.fbq = n
    if (!f._fbq) f._fbq = n

    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
}

export function trackPageView(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(): void {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: '30 Días para Despertar tu Ser',
      content_type: 'product',
      value: 19999,
      currency: 'ARS',
    })
  }
}
